import React, { useState, memo } from 'react';
import { useMEMTranslation } from '../../utils/text-utils';
import { useTrackInteraction } from '../../services/logging/hooks';
import { usePageContext } from '../../utils/page-context';
import { useAvailableManagerCadences } from './hooks';
import { Option, Combobox } from '../../providers/harmony-scope/lazy-enablers';
import { EPartitionCadence } from '../../ducks/filters/types-filters';

interface IProps {
  selectedManagerPartitionGroupName: string;
  selectedCadence: EPartitionCadence;
  onChange: (partitionCadence: EPartitionCadence) => void;
}

const componentName = 'Manager Cadence Picker Filters Panel';
export const ComponentFilterManagerCadence = memo((props: IProps) => {
  // Props Accessors
  const { selectedCadence: selectedCadenceProp, selectedManagerPartitionGroupName, onChange } = props;

  // Hooks
  const { t } = useMEMTranslation();
  const pageName = usePageContext();
  const trackInteraction = useTrackInteraction();
  const availableCadences = useAvailableManagerCadences(selectedManagerPartitionGroupName);
  const [selectedCadence, setSelectedCadence] = useState(selectedCadenceProp);

  // Handlers
  const cadenceChanged = (event: any) => {
    if (!event.target.value) return;
    const newPartitionCadence = event.target.value;
    trackInteraction('Selected manager cadence', pageName, componentName, {
      selectedParticipationCadence: newPartitionCadence,
    });
    setSelectedCadence(newPartitionCadence);
    onChange(newPartitionCadence);
  };

  return availableCadences.length > 1 ? (
    <>
      <Combobox label={t('filtersPanelPartitionCadenceLabel')} value={selectedCadence} onHeChange={cadenceChanged}>
        {availableCadences.map((p) => (
          <Option key={`${p.partitionCadence}`} value={`${p.partitionCadence}`} title={`${p.partitionCadence}`}>
            {`${p.partitionCadence}`}
          </Option>
        ))}
      </Combobox>
      <br />
    </>
  ) : null;
});
